(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getHomeRoot = () => document.querySelector('[data-bc-home-hero]');

    function publish(name, payload) {
      const detail = { home_version: 'native-v1', ...payload };
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...detail });
      try {
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish(`butter_crust:${name}`, detail);
        }
      } catch (error) {
        // Tracking must never interrupt navigation.
      }
    }

    function initHomeTracking() {
      if (document.documentElement.dataset.bcHomeTrackingReady === 'true') return;
      document.documentElement.dataset.bcHomeTrackingReady = 'true';

      document.addEventListener('click', (event) => {
        const link = event.target.closest('[data-bc-home-cta]');
        if (!link) return;
        const payload = {
          cta_id: link.dataset.bcHomeCta || '',
          preset_id: link.dataset.bcHomePreset || '',
          section_id: link.closest('[data-bc-home-section]')?.dataset.bcHomeSection || '',
          destination: link.getAttribute('href') || '',
        };
        publish('bc_home_cta_click', payload);
        if (payload.preset_id) publish('bc_home_preset_click', payload);
      });

      if (!('IntersectionObserver' in window)) return;
      const viewed = new WeakSet();
      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || viewed.has(entry.target)) return;
          viewed.add(entry.target);
          publish('bc_home_section_view', {
            section_id: entry.target.dataset.bcHomeSection || '',
          });
          sectionObserver.unobserve(entry.target);
        });
      }, { threshold: 0.35 });
      document.querySelectorAll('[data-bc-home-section]').forEach((section) => sectionObserver.observe(section));
    }

    function initSticky() {
      const hero = getHomeRoot();
      const sticky = hero?.querySelector('[data-bc-home-sticky]');
      const primaryCta = hero?.querySelector('[data-bc-home-cta="hero-primary"]');
      if (!hero || !sticky || hero.dataset.bcHomeStickyReady === 'true') return;
      hero.dataset.bcHomeStickyReady = 'true';

      let frame = 0;
      const update = () => {
        frame = 0;
        const threshold = primaryCta || hero;
        const visible = window.matchMedia('(min-width: 750px)').matches
          && threshold.getBoundingClientRect().bottom <= 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.tabIndex = visible ? 0 : -1;
      };

      const requestUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      window.addEventListener('pageshow', requestUpdate);
    }

    initHomeTracking();
    initSticky();
    document.addEventListener('shopify:section:load', () => {
      initHomeTracking();
      initSticky();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-home-product-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseProductMenu = (root) => {
      if (!root || root.dataset.bcProductMenuReady === 'true') return;
      root.dataset.bcProductMenuReady = 'true';

      const cta = root.querySelector('[data-bc-product-cta]');
      const productLinks = Array.from(root.querySelectorAll('[data-bc-product-link]'));
      const sectionWrapper = root.closest('.shopify-section');
      const wrappers = Array.from(document.querySelectorAll('main .shopify-section'));
      const sectionPosition = Math.max(1, wrappers.indexOf(sectionWrapper) + 1);
      let viewed = false;
      let viewTimer = 0;

      const publish = (name, payload = {}) => {
        const detail = { section_position: sectionPosition, ...payload };
        root.dataset.bcProductLastEvent = name;
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...detail });
        try {
          window.Shopify?.analytics?.publish?.(`butter_crust:${name}`, detail);
        } catch (error) {
          // Analytics must never interrupt navigation or rendering.
        }
      };

      if (cta) {
        const destination = new URL(cta.getAttribute('href') || '/', window.location.origin);
        const currentParams = new URLSearchParams(window.location.search);
        const exactCarryKeys = new Set([
          'discount', 'gclid', 'fbclid', 'ttclid', 'irclickid', 'experiment', 'variant', 'bc_variant',
        ]);
        currentParams.forEach((value, key) => {
          const carry = key.startsWith('utm_') || key.startsWith('bc_experiment') || key.startsWith('bc_test_') || exactCarryKeys.has(key);
          if (carry && !destination.searchParams.has(key)) destination.searchParams.set(key, value);
        });
        cta.setAttribute('href', `${destination.pathname}${destination.search}${destination.hash}`);
      }

      cta?.addEventListener('click', () => {
        publish('bc_product_section_cta_click', {
          cta_label: cta.querySelector('span')?.textContent.trim() || cta.textContent.trim(),
          destination: cta.getAttribute('href') || '',
        });
      });

      productLinks.forEach((link) => {
        link.addEventListener('click', () => {
          publish('bc_product_card_click', {
            product_handle: link.dataset.bcProductHandle || '',
            destination: link.getAttribute('href') || '',
          });
        });
      });

      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(([entry]) => {
        if (viewed) return;
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
          window.clearTimeout(viewTimer);
          viewTimer = 0;
          root.dataset.bcProductViewState = 'below-threshold';
          return;
        }
        if (viewTimer) return;
        root.dataset.bcProductViewState = 'timing';
        viewTimer = window.setTimeout(() => {
          if (viewed) return;
          viewed = true;
          viewTimer = 0;
          root.dataset.bcProductViewState = 'viewed';
          publish('bc_product_section_view');
          observer.disconnect();
        }, 1000);
      }, { threshold: [0, 0.5, 0.75] });
      observer.observe(root);
    };

    document.querySelectorAll('[data-bc-product-menu]').forEach(initialiseProductMenu);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-bc-product-menu]').forEach(initialiseProductMenu);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-home-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseReviewCarousel = (root) => {
      if (!root || root.dataset.reviewCarouselReady === 'true') return;
      const rail = root.querySelector('[data-review-rail]');
      const previous = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const reviewCount = Number(rail?.dataset.reviewCount || 0);
      const cards = rail ? Array.from(rail.querySelectorAll('[data-review-card]')) : [];
      if (!rail || reviewCount < 2 || cards.length !== reviewCount * 3) return;

      root.dataset.reviewCarouselReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktopAutoplay = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
      let setWidth = 0;
      let settleTimer = 0;
      let resizeTimer = 0;
      let autoplayTimer = 0;
      let autoplaySettleTimer = 0;
      let carouselVisible = !('IntersectionObserver' in window);
      let focusInside = false;
      let dragging = false;
      let pointerId = null;
      let pointerStartX = 0;
      let pointerStartLeft = 0;

      const measureSet = () => {
        const firstCopy = rail.querySelector('[data-review-copy="1"]');
        const middleCopy = rail.querySelector('[data-review-copy="2"]');
        return firstCopy && middleCopy ? middleCopy.offsetLeft - firstCopy.offsetLeft : 0;
      };

      const jumpTo = (left) => {
        rail.classList.add('is-jumping');
        rail.scrollLeft = left;
        requestAnimationFrame(() => rail.classList.remove('is-jumping'));
      };

      const normalise = () => {
        if (dragging || setWidth <= 0) return;
        if (rail.scrollLeft < setWidth * 0.5) {
          jumpTo(rail.scrollLeft + setWidth);
        } else if (rail.scrollLeft > setWidth * 1.5) {
          jumpTo(rail.scrollLeft - setWidth);
        }
      };

      const reset = () => {
        setWidth = measureSet();
        if (setWidth > 0) jumpTo(setWidth);
        scheduleAutoplay();
      };

      const moveByCard = (direction) => {
        const gap = parseFloat(getComputedStyle(rail).columnGap || 0);
        const step = cards[0].getBoundingClientRect().width + gap;
        rail.scrollBy({ left: direction * step, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };

      const getVisibleWordCount = () => {
        const railRect = rail.getBoundingClientRect();
        const visibleWordCounts = cards.reduce((counts, card) => {
          const cardRect = card.getBoundingClientRect();
          const visibleWidth = Math.min(cardRect.right, railRect.right) - Math.max(cardRect.left, railRect.left);
          if (visibleWidth < cardRect.width * 0.55) return counts;
          const title = card.querySelector('h3')?.textContent || '';
          const quote = card.querySelector('blockquote')?.textContent || '';
          const words = `${title} ${quote}`.trim().split(/\s+/).filter(Boolean).length;
          counts.push(words);
          return counts;
        }, []);
        return visibleWordCounts.length ? Math.max(...visibleWordCounts) : 20;
      };

      const getAutoplayPauseReason = () => {
        if (!desktopAutoplay.matches) return 'viewport';
        if (reducedMotion.matches) return 'reduced-motion';
        if (document.hidden) return 'hidden';
        if (!carouselVisible) return 'offscreen';
        if (dragging) return 'dragging';
        if (focusInside) return 'focus';
        return '';
      };

      const clearAutoplay = () => {
        window.clearTimeout(autoplayTimer);
        window.clearTimeout(autoplaySettleTimer);
        autoplayTimer = 0;
        autoplaySettleTimer = 0;
      };

      function scheduleAutoplay() {
        clearAutoplay();
        const pauseReason = getAutoplayPauseReason();
        if (pauseReason) {
          root.dataset.reviewAutoplayState = `paused-${pauseReason}`;
          return;
        }

        const wordCount = getVisibleWordCount();
        const delay = Math.min(7500, Math.max(5200, Math.round(1500 + wordCount * 150)));
        root.dataset.reviewAutoplayState = 'running';
        root.dataset.reviewAutoplayWords = String(wordCount);
        root.dataset.reviewAutoplayDelay = String(delay);
        autoplayTimer = window.setTimeout(() => {
          if (getAutoplayPauseReason()) {
            scheduleAutoplay();
            return;
          }
          root.dataset.reviewAutoplayState = 'moving';
          moveByCard(1);
          autoplaySettleTimer = window.setTimeout(scheduleAutoplay, 900);
        }, delay);
      }

      rail.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveByCard(event.key === 'ArrowRight' ? 1 : -1);
      });

      previous?.addEventListener('click', () => {
        moveByCard(-1);
        scheduleAutoplay();
      });
      next?.addEventListener('click', () => {
        moveByCard(1);
        scheduleAutoplay();
      });

      rail.addEventListener('scroll', () => {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(() => {
          normalise();
          scheduleAutoplay();
        }, 120);
      }, { passive: true });

      if ('onscrollend' in window) rail.addEventListener('scrollend', normalise, { passive: true });

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartLeft = rail.scrollLeft;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(pointerId);
        scheduleAutoplay();
      });

      rail.addEventListener('pointermove', (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        rail.scrollLeft = pointerStartLeft - (event.clientX - pointerStartX);
      });

      const finishDrag = (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        dragging = false;
        rail.classList.remove('is-dragging');
        if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
        pointerId = null;
        normalise();
        scheduleAutoplay();
      };

      rail.addEventListener('pointerup', finishDrag);
      rail.addEventListener('pointercancel', finishDrag);

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(reset, 120);
      }, { passive: true });

      root.addEventListener('focusin', () => {
        focusInside = true;
        scheduleAutoplay();
      });
      root.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          focusInside = root.contains(document.activeElement);
          scheduleAutoplay();
        });
      });

      if ('IntersectionObserver' in window) {
        const visibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            carouselVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
            scheduleAutoplay();
          });
        }, { threshold: [0, 0.25, 0.6] });
        visibilityObserver.observe(root);
      }

      document.addEventListener('visibilitychange', scheduleAutoplay);
      reducedMotion.addEventListener('change', scheduleAutoplay);
      desktopAutoplay.addEventListener('change', scheduleAutoplay);

      requestAnimationFrame(reset);
    };

    document.querySelectorAll('[data-bc-review-carousel]').forEach(initialiseReviewCarousel);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-bc-review-carousel]').forEach(initialiseReviewCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-home-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = Boolean(navigator.connection?.saveData);
    const canAutoplay = () => !reducedMotion.matches && !saveData;
    const isIOSWebKit = (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ) && /AppleWebKit/.test(navigator.userAgent);

    const configureMediaModes = (root = document) => {
      root.querySelectorAll('.bc-home-reviews').forEach((section) => {
        const useImageLoop = isIOSWebKit && !reducedMotion.matches;
        section.classList.toggle('is-ios-image-loop', useImageLoop);
        section.dataset.bcHomeVideoMode = useImageLoop ? 'ios-image-loop' : 'native-video';
        section.querySelectorAll('.bc-home-ugc').forEach((figure) => {
          const figureUsesImageLoop = useImageLoop && Boolean(figure.querySelector('[data-bc-home-video-motion-image]'));
          figure.classList.toggle('is-ios-image-loop', figureUsesImageLoop);
          if (!figureUsesImageLoop) return;
          const video = figure.querySelector('.bc-home-ugc__video');
          video?.pause();
          if (video) video.dataset.bcHomeVideoPlayState = 'ios-image-loop';
        });
      });
    };

    const attemptVideoPlay = async (video) => {
      const figure = video.closest('.bc-home-ugc');
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      try {
        await video.play();
        video.dataset.bcHomeVideoPlayState = 'playing';
        delete video.dataset.bcHomeVideoPlayError;
        if (figure) figure.dataset.bcHomeVideoNeedsInteraction = 'false';
        return true;
      } catch (error) {
        video.dataset.bcHomeVideoPlayState = 'blocked';
        video.dataset.bcHomeVideoPlayError = error?.name || 'unknown';
        if (figure) figure.dataset.bcHomeVideoNeedsInteraction = 'true';
        return false;
      }
    };

    const hydrateVideo = (video, includeSource = true) => {
      if (video.dataset.poster && !video.getAttribute('poster')) {
        video.poster = video.dataset.poster;
      }
      if (includeSource && video.dataset.src && !video.getAttribute('src')) {
        video.src = video.dataset.src;
        video.preload = 'metadata';
        video.load();
        video.dataset.bcHomeVideoHydrated = 'true';
      }
    };

    const hydrateMotionImage = (picture) => {
      if (!picture || picture.dataset.bcHomeVideoHydrated === 'true') return;
      picture.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
      });
      picture.dataset.bcHomeVideoHydrated = 'true';
    };

    const hydrateFigureMedia = (figure) => {
      if (!figure || saveData || !canAutoplay()) return;
      if (figure.classList.contains('is-ios-image-loop')) {
        hydrateMotionImage(figure.querySelector('[data-bc-home-video-motion-image]'));
        figure.dataset.bcHomeVideoHydrated = 'ios-image-loop';
        return;
      }
      const video = figure.querySelector('.bc-home-ugc__video');
      if (!video) return;
      hydrateVideo(video);
      figure.dataset.bcHomeVideoHydrated = 'native-video';
    };

    const initialiseVideoCarousels = (root = document) => {
      root.querySelectorAll('[data-bc-home-video-carousel]').forEach((carousel) => {
        if (carousel.dataset.bcHomeVideoCarouselReady === 'true') return;
        const rail = carousel.querySelector('[data-bc-home-video-rail]');
        const section = carousel.closest('.bc-home-reviews');
        const previous = section?.querySelector('[data-bc-home-video-prev]');
        const next = section?.querySelector('[data-bc-home-video-next]');
        const videoCount = Number(rail?.dataset.bcHomeVideoCount || 0);
        const cards = rail ? Array.from(rail.querySelectorAll('[data-bc-home-video-card]')) : [];
        if (!rail || videoCount < 2 || cards.length !== videoCount * 3 || !previous || !next) return;

        carousel.dataset.bcHomeVideoCarouselReady = 'true';
        let setWidth = 0;
        let settleTimer = 0;
        let resizeTimer = 0;
        let autoplayTimer = 0;
        let autoplaySettleTimer = 0;
        let carouselVisible = !('IntersectionObserver' in window);
        let focusInside = false;
        let dragging = false;
        let pointerId = null;
        let pointerStartX = 0;
        let pointerStartLeft = 0;

        const measureSet = () => {
          const firstCopy = rail.querySelector('[data-bc-home-video-copy="1"]');
          const middleCopy = rail.querySelector('[data-bc-home-video-copy="2"]');
          return firstCopy && middleCopy ? middleCopy.offsetLeft - firstCopy.offsetLeft : 0;
        };

        const jumpTo = (left) => {
          rail.classList.add('is-jumping');
          rail.scrollLeft = left;
          requestAnimationFrame(() => rail.classList.remove('is-jumping'));
        };

        const syncVideoCopies = (sourceCopy, targetCopy) => {
          rail.querySelectorAll(`[data-bc-home-video-copy="${sourceCopy}"]`).forEach((sourceCard) => {
            const key = sourceCard.dataset.bcHomeVideoKey;
            const targetCard = rail.querySelector(`[data-bc-home-video-copy="${targetCopy}"][data-bc-home-video-key="${key}"]`);
            const sourceVideo = sourceCard.querySelector('video');
            const targetVideo = targetCard?.querySelector('video');
            if (!sourceVideo || !targetVideo || !sourceVideo.getAttribute('src')) return;
            hydrateVideo(targetVideo);
            const syncTime = () => {
              if (!Number.isFinite(sourceVideo.currentTime)) return;
              const duration = Number.isFinite(targetVideo.duration) ? targetVideo.duration : sourceVideo.currentTime;
              targetVideo.currentTime = Math.min(sourceVideo.currentTime, duration);
            };
            if (targetVideo.readyState >= 1) syncTime();
            else targetVideo.addEventListener('loadedmetadata', syncTime, { once: true });
          });
        };

        const normalise = () => {
          if (dragging || setWidth <= 0) return;
          if (rail.scrollLeft < setWidth * 0.5) {
            syncVideoCopies(1, 2);
            jumpTo(rail.scrollLeft + setWidth);
          } else if (rail.scrollLeft > setWidth * 1.5) {
            syncVideoCopies(3, 2);
            jumpTo(rail.scrollLeft - setWidth);
          }
        };

        const moveByCard = (direction) => {
          const gap = parseFloat(getComputedStyle(rail).columnGap || 0);
          const step = cards[0].getBoundingClientRect().width + gap;
          rail.scrollBy({ left: direction * step, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        };

        const getAutoplayPauseReason = () => {
          if (reducedMotion.matches) return 'reduced-motion';
          if (document.hidden) return 'hidden';
          if (!carouselVisible) return 'offscreen';
          if (dragging) return 'dragging';
          if (focusInside) return 'focus';
          return '';
        };

        const clearAutoplay = () => {
          window.clearTimeout(autoplayTimer);
          window.clearTimeout(autoplaySettleTimer);
          autoplayTimer = 0;
          autoplaySettleTimer = 0;
        };

        function scheduleAutoplay() {
          clearAutoplay();
          const pauseReason = getAutoplayPauseReason();
          if (pauseReason) {
            carousel.dataset.bcHomeVideoAutoplayState = `paused-${pauseReason}`;
            return;
          }
          carousel.dataset.bcHomeVideoAutoplayState = 'running';
          carousel.dataset.bcHomeVideoAutoplayDelay = '4400';
          autoplayTimer = window.setTimeout(() => {
            if (getAutoplayPauseReason()) {
              scheduleAutoplay();
              return;
            }
            carousel.dataset.bcHomeVideoAutoplayState = 'moving';
            moveByCard(1);
            autoplaySettleTimer = window.setTimeout(scheduleAutoplay, 900);
          }, 4400);
        }

        const reset = () => {
          setWidth = measureSet();
          if (setWidth > 0) jumpTo(setWidth);
          scheduleAutoplay();
        };

        previous.addEventListener('click', () => {
          moveByCard(-1);
          scheduleAutoplay();
        });
        next.addEventListener('click', () => {
          moveByCard(1);
          scheduleAutoplay();
        });

        rail.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          moveByCard(event.key === 'ArrowRight' ? 1 : -1);
          scheduleAutoplay();
        });

        rail.addEventListener('scroll', () => {
          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(() => {
            normalise();
            scheduleAutoplay();
          }, 140);
        }, { passive: true });

        if ('onscrollend' in window) rail.addEventListener('scrollend', normalise, { passive: true });

        rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragging = true;
          pointerId = event.pointerId;
          pointerStartX = event.clientX;
          pointerStartLeft = rail.scrollLeft;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(pointerId);
          scheduleAutoplay();
        });

        rail.addEventListener('pointermove', (event) => {
          if (!dragging || event.pointerId !== pointerId) return;
          rail.scrollLeft = pointerStartLeft - (event.clientX - pointerStartX);
        });

        const finishDrag = (event) => {
          if (!dragging || event.pointerId !== pointerId) return;
          dragging = false;
          rail.classList.remove('is-dragging');
          if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
          pointerId = null;
          normalise();
          scheduleAutoplay();
        };

        rail.addEventListener('pointerup', finishDrag);
        rail.addEventListener('pointercancel', finishDrag);

        window.addEventListener('resize', () => {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(reset, 140);
        }, { passive: true });

        section.addEventListener('focusin', () => {
          focusInside = true;
          scheduleAutoplay();
        });
        section.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            focusInside = section.contains(document.activeElement);
            scheduleAutoplay();
          });
        });

        if ('IntersectionObserver' in window) {
          const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              carouselVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
              scheduleAutoplay();
            });
          }, { threshold: [0, 0.25, 0.6] });
          visibilityObserver.observe(section);
        }

        document.addEventListener('visibilitychange', scheduleAutoplay);
        reducedMotion.addEventListener('change', scheduleAutoplay);
        requestAnimationFrame(reset);
      });
    };

    const videoObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach(async (entry) => {
            const video = entry.target;
            const figure = video.closest('.bc-home-ugc');
            if (!figure) return;
            const inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            figure.dataset.bcHomeVideoInView = String(inView);
            if (!inView || document.hidden) {
              video.pause();
              video.dataset.bcHomeVideoPlayState = 'paused';
              return;
            }
            if (figure.classList.contains('is-ios-image-loop')) {
              video.pause();
              video.dataset.bcHomeVideoPlayState = 'ios-image-loop';
              return;
            }
            if (!canAutoplay()) {
              video.pause();
              video.dataset.bcHomeVideoPlayState = 'manual';
              figure.dataset.bcHomeVideoNeedsInteraction = 'true';
              return;
            }
            hydrateVideo(video);
            await attemptVideoPlay(video);
          });
        }, { rootMargin: '80px 24px', threshold: [0, 0.2, 0.55, 1] })
      : null;

    const mediaObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            hydrateFigureMedia(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '700px 120px', threshold: 0.01 })
      : null;

    const initialiseVideos = (root = document) => {
      root.querySelectorAll('.bc-home-ugc__video').forEach((video) => {
        if (video.dataset.bcHomeVideoReady === 'true') return;
        video.dataset.bcHomeVideoReady = 'true';
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('webkit-playsinline', '');

        const figure = video.closest('.bc-home-ugc');

        const retryWhenReady = async () => {
          if (
            figure?.dataset.bcHomeVideoInView !== 'true' ||
            !canAutoplay() ||
            document.hidden ||
            figure?.classList.contains('is-ios-image-loop')
          ) return;
          await attemptVideoPlay(video);
        };

        video.addEventListener('loadeddata', retryWhenReady, { once: true });
        video.addEventListener('canplay', retryWhenReady, { once: true });

        if (!canAutoplay()) {
          video.pause();
        }

        if (mediaObserver) {
          if (figure) mediaObserver.observe(figure);
        } else {
          hydrateFigureMedia(figure);
        }
        videoObserver?.observe(video);
      });
    };

    configureMediaModes();
    initialiseVideos();
    initialiseVideoCarousels();

    const syncAutoplay = () => {
      configureMediaModes();
      document.querySelectorAll('.bc-home-ugc__video').forEach(async (video) => {
        const figure = video.closest('.bc-home-ugc');
        if (figure?.classList.contains('is-ios-image-loop')) {
          video.pause();
          video.dataset.bcHomeVideoPlayState = 'ios-image-loop';
          return;
        }
        if (document.hidden || !canAutoplay()) {
          video.pause();
          return;
        }
        if (
          figure?.dataset.bcHomeVideoInView === 'true' &&
          canAutoplay()
        ) {
          hydrateVideo(video);
          await attemptVideoPlay(video);
        }
      });
    };

    const playVisibleFromGesture = (section) => {
      section.querySelectorAll('.bc-home-ugc__video').forEach((video) => {
        if (video.closest('.bc-home-ugc')?.classList.contains('is-ios-image-loop')) return;
        const rect = video.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth) return;
        hydrateVideo(video);
        attemptVideoPlay(video);
      });
    };

    const initialiseGestureFallbacks = (root = document) => {
      root.querySelectorAll('.bc-home-reviews').forEach((section) => {
        if (section.dataset.bcHomeVideoGestureReady === 'true') return;
        section.dataset.bcHomeVideoGestureReady = 'true';
        section.addEventListener('touchstart', () => playVisibleFromGesture(section), { passive: true });
        section.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch' || event.pointerType === 'pen') playVisibleFromGesture(section);
        }, { passive: true });
      });
    };

    initialiseGestureFallbacks();
    document.addEventListener('visibilitychange', syncAutoplay);
    window.addEventListener('pageshow', syncAutoplay, { passive: true });
    window.addEventListener('focus', syncAutoplay, { passive: true });
    reducedMotion.addEventListener('change', () => {
      configureMediaModes();
      syncAutoplay();
    });
    document.addEventListener('shopify:section:load', (event) => {
      configureMediaModes(event.target);
      initialiseVideos(event.target);
      initialiseVideoCarousels(event.target);
      initialiseGestureFallbacks(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
